import React, { useCallback } from 'react';
import useAPI from '../../../api';
import { Paper, Stack } from '@mui/material';
import KanbanGroupHeader from './KanbanGroupHeader';
import CustomerCard from './CustomerCard';
import { FullSizeColumn } from '../../../Components/FlexBox';
import useInfiniteQuery from '../../../Hooks/useInfiniteQuery';
import mapFilters from '../../../Helpers/Filters/mapFilters';

const renderCustomerCard = ({
  customerId,
  customerFullName,
  createdByFullName,
  lastActivity,
}) => {
  const { activityType, completedOn, createdOn, completedByFullName } =
    lastActivity || {};
  return (
    <CustomerCard
      key={customerId}
      id={customerId}
      customerName={customerFullName}
      lastActivityType={activityType}
      lastActivityCompletedOn={completedOn ?? createdOn}
      lastActivityCompletedBy={completedByFullName ?? createdByFullName}
    />
  );
};

const KanbanGroup = function KanbanGroup({
  id,
  campaignId,
  name,
  isFirst,
  isLast,
  advancementThreshold,
  lowerThreshold,
  color,
  width,
  filters,
  branchId,
  description,
}) {
  const API = useAPI();

  const getPaginatedCustomers = useCallback(
    (pageNumber) => {
      return API.getPaginatedDividerCustomers(id, campaignId, {
        pageNumber,
        silent: true,
        filterExpression: mapFilters(
          ['customerFullName'],
          [
            { keyName: 'branchId', operator: 'eq' },
            { keyName: 'completedBy', operator: 'eq' },
          ],
          [],
          {
            ...filters,
            branchId,
            completedBy: filters.operatorId === 0 ? null : filters.operatorId,
          }
        ),
      });
    },
    [id, campaignId, filters, branchId]
  );

  const { ObserverWrapper, recordCount } = useInfiniteQuery(
    getPaginatedCustomers
  );

  return (
    <Paper
      id={`kanban-group-${id}`}
      sx={{
        padding: '4px',
        width,
        minWidth: '360px',
        borderRadius: '24px',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <KanbanGroupHeader
        description={description}
        title={name}
        count={recordCount < 0 ? 0 : recordCount}
        color={color}
        isFirst={isFirst}
        isLast={isLast}
        lowerThreshold={lowerThreshold}
        advancementThreshold={advancementThreshold}
      />
      <FullSizeColumn sx={{ overflow: 'hidden', padding: '16px 0px' }}>
        <Stack
          spacing={1}
          sx={{ height: '100%', padding: '0px 8px', overflowY: 'auto' }}
        >
          <ObserverWrapper Component={renderCustomerCard} />
        </Stack>
      </FullSizeColumn>
    </Paper>
  );
};

export default KanbanGroup;
